export function getObjectSize(object) {
	const jsonString = JSON.stringify(object);
	const sizeInBytes = new Blob([jsonString], { type: "application/json" }).size;
	return sizeInBytes;
}

export function escapeSpecialChars(value) {
	console.log("value===>", value);
	if (typeof value === "string") {
		return value.replace(/[\\"']/g, "\\$&").replace(/\u0000/g, "\\0");
	} else if (Array.isArray(value)) {
		return value.map((item) => escapeSpecialChars(item));
	} else if (value !== null && typeof value === "object") {
		const escapedObject = {};
		for (const key in value) {
			escapedObject[key] = escapeSpecialChars(value[key]);
		}
		return escapedObject;
	}
	return value;
}
